/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityShippingDetailPage = lazyLoad(
  () => import('./index'),
  module => module.EntityShippingDetailPage
);
